export default function MySQL_JOINS() {
  return (
    <div>
      <h2>MySQL_JOINS</h2>    </div>
  );
}